import { render } from "./HomeTemplate.vue?vue&type=template&id=21896fb6&scoped=true"
import script from "./HomeTemplate.vue?vue&type=script&lang=ts"
export * from "./HomeTemplate.vue?vue&type=script&lang=ts"

import "./HomeTemplate.vue?vue&type=style&index=0&id=21896fb6&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-21896fb6"

export default script